class AutoHeight {
    constructor(domElm) {
        this.domElm = domElm;
        this.addListeners();
    }

    addListeners() {
        window.addEventListener("resize", this.setMaxHeight);
        this.setMaxHeight();
    }

    setMaxHeight() {
        this.domElm.style.setProperty('--max-height', this.domElm.scrollHeight + "px");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[auto-height],.menu-item-has-children > ul").forEach((elm) => {
        new AutoHeight(elm);
    })
})